// SUS-100: o modal da cotação só guardava o CNPJ do remetente, e ninguém sabe
// de cabeça que 09.445.964/0002-07 é Porto Belo. A unidade sai da mesma lista
// que a Nova Cotação usa para escolher o remetente (GET /embarcadores/:id),
// casada pelo CNPJ.
//
// Compatível com o build em Node 12 (CRA 3.4): sem ?. nem ??.

const soDigitos = (v) => String(v === null || v === undefined ? "" : v).replace(/\D/g, "");

// Devolve { nome, cnpj } da unidade de origem, ou null quando a cotação não
// tem CNPJ do remetente. Sem casamento na lista, nome fica null e a tela
// mostra só o CNPJ.
export function unidadeOrigemDe(remetentes, cnpjRemetente) {
  const cnpj = soDigitos(cnpjRemetente);
  if (!cnpj) return null;

  const lista = Array.isArray(remetentes) ? remetentes : [];
  const achada = lista.find(
    (r) => r && soDigitos(r.cnpjRemetente || r.embarcador_cnpj || r.cnpj) === cnpj
  );

  return {
    nome: achada && achada.embarcador_fantasia ? achada.embarcador_fantasia : null,
    cnpj,
  };
}
